// Extracted from `src/hooks/query/useQueryLiveTranscriptBySessionId.ts`, which
// keeps the rest of the live-transcript hub app-side (it reads the Redux timer,
// the capture store and the flags barrel) and now re-exports this name from
// `@heidi/session/data`, so no consumer path changed.
// History: git log --follow -- src/hooks/query/useQueryLiveTranscriptBySessionId.ts

import { readLiveTranscriptCache } from './live-transcript-cache';

/**
 * Cache-only read: does this session's live transcript hold any text at all?
 *
 * The transcript-deleted rule pairs the backend marker with this read, because
 * the backend does not clear `transcript_deleted_at` on re-record — so a
 * repopulated live cache is what tells a stale marker from a live one.
 */
export function areAllTranscriptsEmpty(sessionId: string): boolean {
  const transcripts = readLiveTranscriptCache(sessionId);
  const live = transcripts?.live;
  if (!live || live.length === 0) return true;
  return live.every((recordingChunk) =>
    recordingChunk.chunks.every(
      (chunk) => !chunk.transcript || chunk.transcript.trim() === ''
    )
  );
}
